import type { UnpatchedConsole } from './types';

export const defaultUnpatchedConsole: UnpatchedConsole = { ...console };
